<template>
  <v-dialog
    v-model="dialog"
    scrollable
    :overlay="false"
    min-width="600px"
    max-width="900px"
    transition="dialog-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn small icon color="success" v-bind="attrs" v-on="on">
        <v-icon>
          mdi-account-cog
        </v-icon>
      </v-btn>
    </template>
    <v-card>
      <!-- {{ CustomerID }} -->
      <v-card-title primary-title class="headline grey lighten-3">
        {{ CustomerID.FullName }}
        <v-spacer></v-spacer>
        <v-btn @click="dialog = false" text icon color="primary">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row class=" justify-space-around">
          <v-col cols="12" md="5" sm="12" lg="5">
            <v-card light class="shape">
              <v-toolbar color="white">
                <!-- <v-btn icon color="black">
                <v-icon>mdi-pen</v-icon>
              </v-btn> -->
                <EditeClient :ClientInfo="CustomerID"></EditeClient>
                <v-toolbar-title>{{ CustomerID.FullName }}</v-toolbar-title>

                <v-spacer></v-spacer>
                <AddUser :ClientInfo="CustomerID"></AddUser>
              </v-toolbar>
              <v-card-text class="black--text subtitle-1">
                <v-row>
                  <v-col cols="6"> Phone:</v-col>
                  <v-col cols="6">{{ CustomerID.Cusphone }}</v-col>
                  <v-col cols="6"> ID Number:</v-col>
                  <v-col cols="6">{{ CustomerID.IDNomber }}</v-col>
                  <v-col cols="6"> Reg Date:</v-col>
                  <v-col cols="6"> {{ CustomerID.RegDate }}</v-col>
                  <v-col cols="6"> Account:</v-col>
                  <v-col cols="6">{{ CustomerID.AccountNumber }}</v-col>
                </v-row>
              </v-card-text>
              <!-- <v-divider></v-divider> -->
              <v-card-actions class="yellow darken-1 justify-center">
                <p v-if="Balance.length === 0">
                  {{ EmptyMessage }}
                </p>
                <v-chip-group
                  active-class="green white--text"
                  v-model="selection"
                  text-color="white"
                  center-active
                  column
                  dark
                >
                  <template v-for="(item, index) in Balance">
                    <v-chip
                      pill
                      :color="item.loan === 'yess' ? '#E57373' : 'black'"
                      text-color="white"
                      active-class="green"
                      light
                      :key="index"
                      >{{ item.Amount.toLocaleString() }}
                      <v-avatar
                        size="avatarSize"
                        :color="item.loan === 'yess' ? '#D50000' : '#FFECB3'"
                        class="black--text pa-4 my-4"
                        right
                      >
                        {{ item.AmountType | MoneySigns }}
                      </v-avatar>
                    </v-chip>
                  </template>
                </v-chip-group>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="12" md="5" sm="12" lg="5">
            <v-card class="shape">
              <v-card-title primary-title class="justify-center headline">
                {{ CustomerID.FullName }}
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-container grid-list-lg>
                  <v-row>
                    <v-col cols="12">
                      <deposit
                        :Finished="AffterDeposit"
                        :AccountNumber="CustomerID.AccountNumber"
                      ></deposit>
                    </v-col>
                    <v-col cols="12">
                      <withdraw
                        :FinishedWithdrow="AffterDeposit"
                        :AccountNumber="CustomerID.AccountNumber"
                      ></withdraw>
                    </v-col>
                    <v-col cols="12">
                      <ToAccount
                        :FinishedWithdrow="AffterDeposit"
                        :AccountNumber="CustomerID.AccountNumber"
                        :SenderName="CustomerID.FullName"
                      ></ToAccount>
                    </v-col>
                    <v-col cols="12">
                      <Exchange
                        v-if="CopManyInfo.companyName !== 'IMAW ACCOUNTING'"
                        :Finished="AffterDeposit"
                        :AccountNumber="CustomerID.AccountNumber"
                      ></Exchange>
                    </v-col>
                  </v-row>
                  <!-- {{ CopManyInfo }} -->
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { tokenMixin } from "@/Mixins/tokenMixins";

import deposit from "@/components/Clients/Deposit";
import withdraw from "@/components/Clients/Withdraw";
import ToAccount from "@/components/Clients/ToAccount";
import Exchange from "@/components/Clients/clientExchange";
import AddUser from "@/components/Clients/AddUser";
import EditeClient from "@/components/Clients/editClient.vue";
export default {
  mixins: [tokenMixin],
  components: { deposit, withdraw, Exchange, AddUser, EditeClient, ToAccount },
  // props: ["CustomerID"],
  props: {
    CustomerID: { type: Object, required: true },
  },
  data() {
    return {
      dialog: false,
      selection: -1,
      EmptyMessage: "",
      Balance: [],
    };
  },
  methods: {
    AffterDeposit(amount) {
      if (amount.length > 0) {
        this.selection = -1;
        for (let index = 0; index < this.Balance.length; index++) {
          if (amount[index].Amount != this.Balance[index].Amount) {
            this.selection = index;
            break;
          }
        }
        if (this.selection === -1 && amount.length > this.Balance.length)
          this.selection = amount.length - 1;
        this.Balance = amount;
      }
      //   console.log(amount);
    },
    ShowBalance(item) {
      this.Balance = [];
      this.EmptyMessage = "";
      // console.log(ID);
      this.$store
        .dispatch("INSERT_ONLY", {
          url: "/customer/balance",
          data: {
            AccountNumber: item.AccountNumber,
          },
        })
        .then(result => {
          if (result.data.length === 0)
            this.EmptyMessage = "This Account is Empty";
          // console.log(result);
          if (result.status === 200) {
            this.Balance = result.data;
            // this.Balance.Name = item.FullName;
          }
        })
        .catch(() => {
          this.EmptyMessage = "something is wrong plz try again!!!";
          // console.log(error);
        });
    },
  },
  created() {
    this.ShowBalance(this.CustomerID);
  },
};
</script>
<style scoped>
.shape {
  border-top-left-radius: 25px;
  border-bottom-right-radius: 25px;
}
</style>
